import { render, staticRenderFns } from "./scale-prop.vue?vue&type=template&id=638e7938&scoped=true&"
import script from "./scale-prop.vue?vue&type=script&lang=js&"
export * from "./scale-prop.vue?vue&type=script&lang=js&"
import style0 from "./scale-prop.vue?vue&type=style&index=0&id=638e7938&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638e7938",
  null
  
)

component.options.__file = "scale-prop.vue"
export default component.exports